<template lang="pug">
	.card
		.card-header.bg-dark.text-white
			.row
				.col
					span.fa.fa-list.mr-2
					| Resultados
				.col.text-right
					.btn-group
						download-excel(
							class   = "btn btn-warning btn-sm"
							:data   = "listadoXLS"
							:fields = "json_fields"
							:meta   = "json_meta"
							name	= "invitados.xls")

							span.fa.fa-download.mr-2
							| XLS
						button.btn.btn-primary.btn-sm(
							@click="$emit('descargar')"
						)
							span.fa.fa-file-pdf-o.mr-2
							| PDF
		table.table.table-striped.m-0
			thead
				tr
					th(style="cursor:pointer;" @click="setOrden('GrupoNombre')")
						| Grupo
						span(v-if="orden.OrdenColumna === 'GrupoNombre'")
							span.ml-3.fa(:class="(orden.OrdenSentido === 'asc') ? 'fa-caret-up' : 'fa-caret-down'")
					th(style="cursor:pointer;" @click="setOrden('Nombre')")
						| Nombre
						span(v-if="orden.OrdenColumna === 'Nombre'")
							span.ml-3.fa(:class="(orden.OrdenSentido === 'asc') ? 'fa-caret-up' : 'fa-caret-down'")
					th(style="cursor:pointer;" @click="setOrden('Estado')")
						| Estado
						span(v-if="orden.OrdenColumna === 'Estado'")
							span.ml-3.fa(:class="(orden.OrdenSentido === 'asc') ? 'fa-caret-up' : 'fa-caret-down'")
					th(style="cursor:pointer;" @click="setOrden('UsuarioNombre')")
						| Gestiona
						span(v-if="orden.OrdenColumna === 'UsuarioNombre'")
							span.ml-3.fa(:class="(orden.OrdenSentido === 'asc') ? 'fa-caret-up' : 'fa-caret-down'")
					th(style="cursor:pointer;" @click="setOrden('Asistentes')")
						| Asistentes
						span(v-if="orden.OrdenColumna === 'Asistentes'")
							span.ml-3.fa(:class="(orden.OrdenSentido === 'asc') ? 'fa-caret-up' : 'fa-caret-down'")
					th(style="cursor:pointer;" @click="setOrden('Localidades')")
						| Localidades
						span(v-if="orden.OrdenColumna === 'Localidades'")
							span.ml-3.fa(:class="(orden.OrdenSentido === 'asc') ? 'fa-caret-up' : 'fa-caret-down'")
					th(style="cursor:pointer;" @click="setOrden('Anotaciones')")
						| Anotaciones
						span(v-if="orden.OrdenColumna === 'Anotaciones'")
							span.ml-3.fa(:class="(orden.OrdenSentido === 'asc') ? 'fa-caret-up' : 'fa-caret-down'")
					th
			tbody
				tr(v-for="invitado in listado", :key="invitado.InvitadoID", :class="estiloInvitado(invitado)")
					td {{invitado.GrupoNombre}}
					td
						b.mr-3(v-if="invitado.VIP")
							span.fa.fa-star
						| {{invitado.Nombre}}
					td {{invitado.Estado}}
					td
						div {{invitado.UsuarioOriginalNombre}}
						div(style="opacity:0.5;font-style:italic;", v-if="invitado.UsuarioID !== invitado.UsuarioOriginalID")
							span.fa.fa-edit.mr-2
							| {{invitado.UsuarioNombre}}
					td
						| {{invitado.Asistentes}}
						span.ml-2(v-if="invitado.VIP") ({{invitado.VIP}} VIP)
					td
						div(v-for="loc in invitado.Localidades", :key="loc.Fila+'-'+loc.Asiento")
							span {{loc.FilaNombre}}: A{{loc.Asiento}}
					td {{invitado.Anotaciones}}
					td
						button.btn.btn-sm.btn-warning(@click="$emit('editar', invitado)")
							span.fa.fa-edit.mr-2
							| Editar
		.card-body.bg-dark.text-white
			.row
				.col.text-center
					span(style="font-weight:bold;font-size:2em;")
						| {{listado.length}}
						br
						| invitados
				.col.text-center
					span(style="font-weight:bold;font-size:2em;")
						| {{sumaAsistentes}}
						br
						| asistentes
				.col.text-center
					span(style="font-weight:bold;font-size:2em;")
						| {{sumaVIPS}}
						br
						| VIPs
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	props: ['resultados', 'orden'],
	computed: {
		...mapGetters({
			usuario: 'session/usuario'
		}),
		listado () {
			if (!this.orden.OrdenColumna) {
				return this.resultados
			}

			return this.resultados.sort((a, b) => {
				if (a[this.orden.OrdenColumna]) {
					if (a[this.orden.OrdenColumna] > b[this.orden.OrdenColumna]) {
						return (this.orden.OrdenSentido === 'asc') ? 1 : -1
					} else if (a[this.orden.OrdenColumna] === b[this.orden.OrdenColumna]) {
						return 0
					} else {
						return (this.orden.OrdenSentido === 'asc') ? -1 : 1
					}
				} else {
					return a
				}
			})
		},
		listadoXLS () {
			return [].concat(this.listado).map(l => {
				if (!l.Localidades) {
					l.LocalidadesSTR = ''
				} else {
					l.LocalidadesSTR = l.Localidades.reduce((acum, localidad) => {
						acum = acum + localidad.FilaNombre + ': A' + localidad.Asiento + ', '
						return acum
					}, '')
				}
				return l
			})
		},
		sumaAsistentes () {
			let suma = 0
			for (let i = 0; i < this.listado.length; i++) {
				suma = suma + this.listado[i].Asistentes
			}
			return suma
		},
		sumaVIPS () {
			let suma = 0
			for (let i = 0; i < this.listado.length; i++) {
				suma = suma + this.listado[i].VIP
			}
			return suma
		},
		json_fields () {
			if (!this.resultados) {
				return {}
			}
			const f = {
				GrupoNombre: 'Grupo',
				Nombre: 'Nombre',
				VIP: 'VIP',
				Estado: 'Estado',
				UsuarioNombre: 'UsuarioNombre',
				Asistentes: 'Asistentes',
				LocalidadesSTR: 'Localidades',
				Anotaciones: 'Anotaciones',
				FechaCreacion: 'FechaCreacion'
			}
			return f
		},

		json_meta () {
			return [
				[{
					'key': 'charset',
					'value': 'utf-8'
				}]
			]
		}
	},
	methods: {
		estiloInvitado (invitado) {
			if (invitado.Estado === 'Denegado') {
				return 'bg-danger text-white'
			} else if (invitado.VIP) {
				return 'bg-warning'
			}

			return ''
		},
		setOrden (campo) {
			if (this.orden.OrdenColumna === campo) {
				this.orden.OrdenSentido = (this.orden.OrdenSentido === 'asc') ? 'desc' : 'asc'
			} else {
				this.orden.OrdenColumna = campo
				this.orden.OrdenSentido = 'asc'
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/invitaciones/vue/components/buscador/resultados.vue